import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { trigger, state, style, animate, transition } from '@angular/animations';
import {
  HttpClient, HttpResponse, HttpRequest,
  HttpEventType, HttpErrorResponse
} from '@angular/common/http';
import { Subscription } from 'rxjs';
import { of } from 'rxjs';
import { catchError, last, map, tap } from 'rxjs/operators';
import { FileUploadModel } from '../model/file-upload-model';
import { AngularFireStorage } from 'angularfire2/storage';
import { UploadService } from '../service/upload.service';
import { UploadTask } from '@angular/fire/storage/interfaces';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-material-img-upload',
  templateUrl: './material-img-upload.component.html',
  styleUrls: ['./material-img-upload.component.css']
})
export class MaterialImgUploadComponent implements OnInit {

  /** Link text */
  @Input() text = 'Cargar';
  /** Name used in form which will be sent in HTTP request. */
  @Input() param = 'file';
  /** Target URL for file uploading. */
  @Input() target = 'https://file.io';
  /** File extension that accepted, same as 'accept' of <input type="file" />. 
      By the default, it's set to 'image/*'. */
  @Input() accept = 'image/*';
  /** Allow you to add handler after its completion. Bubble up response text from remote. */
  @Output() complete = new EventEmitter<any>();


  @Input() formControlName;

  private files: Array<FileUploadModel> = [];

  constructor(private _http: HttpClient, private angularFire: UploadService) { }

  ngOnInit() {
    console.log(this.accept)
  }

  onClick() {
    console.log("aqui",this.accept)
    const fileUpload = document.getElementById('fileUpload') as HTMLInputElement;
    fileUpload.onchange = () => {



      const file = fileUpload.files[0];
      this.files.push({
        data: file, state: 'in',
        inProgress: false, progress: 0, canRetry: false, canCancel: true
      });

      this.uploadFiles();
    };
    fileUpload.click();
  }

  cancelFile(file: FileUploadModel) {
    file.sub.unsubscribe();
    this.removeFileFromArray(file);
  }

  retryFile(file: FileUploadModel) {
    this.uploadFile(file);
    file.canRetry = false;
  }

  private uploadFile(file: FileUploadModel) {

    
    let strin = file.data;
    
    let task: UploadTask = this.angularFire.tareaCloudStorage(file.data.name,file.data);

    let returned = this.isImgForUpload(file.data);

    console.log(returned)
      
    if(this.isImgForUpload(file.data) == true){
      
      task.then(onFull=>{
        let url  = onFull.ref.getDownloadURL().then(data=>{
         this.files = [];
         this.complete.emit(data);
        })
        
    
        
     }, error=>{
       Swal.fire("Error","No se pudo almacenar la imagen","error")
     })
    }else{
      console.log("error")
      this.complete.emit(file.data)
      this.files = [];
    }
   
    //let url = task.snapshot.ref.getDownloadURL();
    

  }


  isImgForUpload(file){

    let fileType = ['csv', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'application/vnd.ms-excel']
    let returnd = false;
    fileType.forEach(element =>{
      console.log(file.type)
      if(file.type == element){
        console.log(file.type,"aqui",element, false)
        console.log(returnd,"wowo")
        return returnd;
      }
    })

    return true;
  }

  private uploadFiles() {
    const fileUpload = document.getElementById('fileUpload') as HTMLInputElement;
    fileUpload.value = '';

    this.files.forEach(file => {
      this.uploadFile(file);
    });
  }

  private removeFileFromArray(file: FileUploadModel) {
    const index = this.files.indexOf(file);
    if (index > -1) {
      this.files.splice(index, 1);
    }
  }

}
